import './services/localization/i18n';
import 'array-flat-polyfill';

import React from 'react';
import { StyleSheet, View } from 'react-native';
import { enableScreens } from 'react-native-screens';
import { QueryClient, QueryClientProvider } from 'react-query';
import { NavigationContainer } from '@react-navigation/native';
import { RecoilRoot } from 'recoil';

import { ConfigGateway, Theme, WithAxios } from '@constants';
import { navigationService } from '@services';

import { AppNavigator } from './_AppNavigator/AppNavigator';
import { UserSettingsSetup } from './components/UserSettingsSetup/UserSettingsSetup';
import { isTizen, isVizio } from './helpers/Platform';
import { AppProvider } from './AppProvider';

import { VizioSetup } from '../web/vizio/app/setup/VizioSetup';

// React Query setup
const queryClient = new QueryClient();

// Enable screens
enableScreens();

const handleHideSplashScreen = () => {
  if (isTizen) {
    setTimeout(() => window.screen.show(), 400);
  }
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <RecoilRoot>
      <ConfigGateway>
        <UserSettingsSetup />
        {isVizio && <VizioSetup />}
        <AppProvider>
          <NavigationContainer ref={navigationService.navigationRef} onReady={() => handleHideSplashScreen()}>
            <WithAxios>
              <View style={styles.app}>
                <AppNavigator />
              </View>
            </WithAxios>
          </NavigationContainer>
        </AppProvider>
      </ConfigGateway>
    </RecoilRoot>
  </QueryClientProvider>
);

export default App;

const styles = StyleSheet.create({
  app: {
    flex: 1,
    flexDirection: 'column',
    height: Theme.px(1080),
    width: Theme.px(1920),
  },
});
